import {Injectable} from "@angular/core";
import {Response} from "@angular/http";
import {Observable} from "rxjs";
import { map } from "rxjs/operators";
import {HttpClient} from "../httpclient";
import {Brand} from "./brand.model";
import {Kpi} from "./kpi.model";
import {Grid} from "./grid.model";
import {StorageService} from '../auth/storage.service';


@Injectable()
export class HomeService {

    constructor(private httpClient: HttpClient, private storageService : StorageService) { }

    private assetsPath = '/assets-service/';
    private uaaPath = '/uaa-service/';
    private uiPath = '/ui-service/';

    getAccount(): Observable<any> {
        return this.httpClient.get(this.uaaPath + 'accounts/rel/' +  this.storageService.getCurrentUser().accountId).pipe(map(this.extractData));
    }
    
    getDashboards(): Observable<any> {
        return this.httpClient.get(this.assetsPath + 'dashboard').pipe(map(this.extractData));
    }
    
    getKpis(): Observable<Kpi[]> {
        return this.httpClient.get(this.assetsPath + 'kpis').pipe(map(this.extractData));
    }

    getGrid(gridType : string): Observable<any[]> {
        return this.httpClient.get(this.assetsPath + 'movements/summarized/' + gridType ).pipe(map(this.extractData));
    }

    getBrand(): Observable<Brand> {
        return this.httpClient.get(this.uaaPath + 'accounts/' + this.storageService.getCurrentUser().accountId + '/brand').pipe(map(this.extractData));
    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }
}

